import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

// Import slick-carousel css
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import carousel1 from "../assets/maximize-refund.png"
import carousel2 from "../assets/carousel2.png"
import carousel3 from "../assets/global-tax-compliance.png"
import carousel4 from "../assets/IRS.png"
import PersonalTaxPreparation from "../assets/personalTaxPreparation.png"
import Scaleup from "../assets/scaleUp.png"
import BusinessKeeping from "../assets/BusinessKeeping.png"
import IRS from "../assets/AuditDefense.png"

const heroCtas = [
  {
    heading: "Maximize Your Refund.",
    sub: "Personal Tax Returns with Top Deductions & Fast Filing.",
    img: carousel1,
    style:{objectFit:"contain"},
    cta: "File Now",
    link: "/taxfiling/tax-preparation"
  },
  {
    heading: "Elevate Your Business.",
    sub: "Strategic Consulting & Back-Office Solutions.",
    img: carousel2,
    cta: "Consult Us",
    link: "/services/business-consulting"
  },
  {
    heading: "Stress-Free International Compliance.",
    sub: "FBAR, FATCA & Global Tax Expertise.",
    img: carousel3,
    cta: "Get Help",
    link: "/taxfiling/fbar-facta-filing"
  },
  {
    heading: "IRS Trouble? We've Got Your Back.",
    sub: "Audit Defense & State/Federal Notice Solutions.",
    img: carousel4,
    cta: "Resolve Now",
    link: "/taxfiling/fdrl-state-notice-resolution"
  }
];

export default function Hero({ content }) {
  useEffect(() => {
    AOS.init({ once: true, duration: 850, easing: "ease-in-out" });
  }, []);

  // Slider settings for infinite auto-scrolling carousel
  const settings = {
    dots: true,
    infinite: true,
    speed: 1200,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: "linear",
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        }
      }
    ],
  };

  return (
    <div>
      {/* HERO BANNER */}
      <section
        className="position-relative py-6 d-flex align-items-center"
        style={{
          minHeight: "92vh",
          width: "100%",
          background:
            "linear-gradient(120deg, #f7f8ff 60%, #f8e0f5 100%)",
          overflow: "hidden"
        }}
      >
        {/* Layered background images for richness */}
        <img
          src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1300&q=80"
          alt="Hero Office"
          style={{
            position: "absolute",
            top: 0, left: 0,
            width: "100vw",
            height: "100%",
            objectFit: "cover",
            opacity: 0.14,
            zIndex: 1
          }}
        />

        {/* Decorative gradients */}
        <div
          aria-hidden
          className="position-absolute w-50 h-100 top-0 end-0"
          style={{
            background: "radial-gradient(circle at 80% 30%, #e9d7f8bb 60%, transparent 100%)",
            zIndex: 2
          }}
        />

        {/* Top text layer */}
        <div className="container position-relative z-3">
          <div className="mb-5 pb-4" data-aos="fade-right">
            <h1 className="display-3 fw-bold mb-3" style={{
              fontFamily: "'Poppins',sans-serif",
              color: "#23284b"
            }}>
              <span
                style={{
                  background: "linear-gradient(90deg, #6B46C1, #D53F8C 70%)",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                  backgroundClip: "text"
                }}
              >
                {content?.title || "Welcome to Nexen Consulting"}
              </span>
              <div className="fw-light mt-2" style={{ color: "#344476" }}>
                {content?.subtitle || "Trusted IT & Tax Expertise for Modern Businesses and Families"}
              </div>
            </h1>
          </div>
          {/* SLIDING BANNER: main USPs/services
          <div className="row flex-nowrap overflow-auto pb-3 mb-3" style={{scrollSnapType:'x mandatory', gap:32}}>
            {heroCtas.map((ct, idx) => (
              <div
                className="col-10 col-sm-6 col-md-4 col-lg-3 flex-shrink-0"
                key={ct.heading}
                style={{scrollSnapAlign:'center'}}
                data-aos="fade-up"
                data-aos-delay={idx*120}
              >
                <div className="card h-100 border-0 shadow-lg p-2 overflow-hidden rounded-4 position-relative service-card-hover">
                  <img
                    src={ct.img}
                    alt={ct.heading}
                    className="rounded-4"
                    style={{width:"100%",maxHeight:128,objectFit:"cover",filter:"brightness(0.93)"}}
                  />
                  <div className="p-3">
                    <div className="fw-bold fs-5 mb-1" style={{
                      color: "#6B46C1",
                      fontFamily: "'Poppins',sans-serif"
                    }}>{ct.heading}</div>
                    <div className="text-secondary mb-2">{ct.sub}</div>
                    <a href={ct.link} className="btn btn-gradient btn-sm rounded-pill px-3 py-2 mt-1"> {ct.cta} </a>
                  </div>
                </div>
              </div>
            ))}
          </div> */}

          {/* Auto-Scrolling Slider */}
          <Slider {...settings}>
            {heroCtas.map((ct, idx) => (
              <div key={idx} className="px-2">
                <div
                  className="card h-100 border-0 shadow-lg p-2 overflow-hidden rounded-4 position-relative"
                  style={{ cursor: "pointer" }}
                  data-aos="fade-up"
                  data-aos-delay={idx * 120}
                >
                  <img
                    src={ct.img}
                    alt={ct.heading}
                    className="rounded-4"
                    style={{
                      width: "100%",
                      maxHeight: 140,
                      objectFit: "cover",
                      filter: "brightness(0.93)"
                    }}
                  />
                  <div className="p-3">
                    <div
                      className="fw-bold fs-5 mb-1"
                      style={{
                        color: "#6B46C1",
                        fontFamily: "'Poppins',sans-serif"
                      }}
                    >
                      {ct.heading}
                    </div>
                    <div className="text-secondary mb-2">{ct.sub}</div>
                    <Link
                      to={ct.link}
                      className="btn btn-gradient btn-sm rounded-pill px-3 py-2 mt-1"
                    >
                      {ct.cta}
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </Slider>

        </div>
        {/* Custom CSS for hero cards */}
        <style>{`
          .btn-gradient {
            background: linear-gradient(90deg, #6B46C1, #D53F8C);
            color: #fff;
            font-weight: 600;
            border: none;
            box-shadow: 0 2px 8px #d53f8c33;
            transition: box-shadow 0.15s,background 0.19s;
          }
          .btn-gradient:hover,.btn-gradient:focus {
            background: linear-gradient(90deg,#D53F8C 60%, #6B46C1);
            box-shadow: 0 6px 24px #d53f8c22;
            color: #fff;
          }
          .service-card-hover {
            transition: transform 0.2s,box-shadow 0.2s;
          }
          .service-card-hover:hover,.service-card-hover:focus-within {
            transform: translateY(-7px) scale(1.03);
            box-shadow: 0 12px 36px #6b46c11c;
            z-index:5;
          }
        `}</style>
      </section >

      {/* CORE SERVICES: as blocks with alternating layout, images, and text */}
      < section className="py-6" style={{ background: "#fff" }
      }>
        <div className="container">
          {[
            {
              img: PersonalTaxPreparation,
              heading: "Personal Tax Preparation",
              text: `Our expert U.S. tax professionals guarantee accurate, maximum refund filing for individuals, families, and expats. Take advantage of every deduction and credit — file online or with a Nexen advisor.`,
              cta: "Start Tax Filing",
              link: "/taxfiling/tax-preparation",
              aos: "fade-right",
              bg: "#edeaff"
            },
            {
              img: Scaleup,
              heading: "Business Consulting & Strategy",
              text: `Future-proof your growth with tailored business consulting, process automation, and digital transformation. Nexen’s consultants are with you from startup to scale-up.`,
              cta: "Consult with Experts",
              link: "/services/business-consulting",
              aos: "fade-left",
              bg: "#f8e8ff"
            },
            {
              img:BusinessKeeping ,
              heading: "Bookkeeping & Accounting",
              text: `Get real-time financial clarity from certified bookkeepers. Payroll, AP/AR, and reporting managed so you can focus on your business — not your paperwork.`,
              cta: "Learn More",
              link: "/services/business-consulting",
              aos: "fade-right",
              bg: "#e0f0ff",
            },
            {
              img: IRS,
              heading: "Audit Defense & IRS Representation",
              text: `Don’t face audits alone. Our seasoned tax professionals represent you from the first IRS notice to final resolution, delivering fairness and peace of mind.`,
              cta: "Resolve Audit",
              link: "/taxfiling/expert-consulting",
              aos: "fade-left",
              bg: "#e8f5e9"
            }
          ].map((block, i) => (
            <div className="row align-items-center mb-5 flex-md-row flex-column-reverse" key={block.heading}
              data-aos={block.aos}
              data-aos-delay={60 * i}
            >
              <div className={`col-md-6 ${i % 2 === 0 ? 'order-md-2 order-2' : 'order-md-1 order-2'}`}>
                <div className="rounded-4 shadow-lg hero-service-img" style={{
                  background: block.bg,
                  padding: 18,
                  minHeight: 240,
                  display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                  <img
                    src={block.img}
                    alt={block.heading}
                    className="img-fluid rounded-3"
                    style={{ objectFit: "contain", maxHeight: 185, width: "100%", }}
                  />
                </div>
              </div>
              <div className={`col-md-6 ${i % 2 === 0 ? 'order-md-1 order-1' : 'order-md-2 order-1'}`}>
                <div className="ps-md-4 pe-md-3 py-3">
                  <h2 className="fw-bold mb-2" style={{ fontSize: "2rem", fontFamily: "'Poppins',sans-serif", color: "#6B46C1" }}>{block.heading}</h2>
                  <p className="fs-5 mb-3 text-secondary">{block.text}</p>
                  <Link to={block.link} className="btn btn-gradient rounded-pill px-4 py-2 mt-1">
                    {block.cta}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section >

      {/* PORTFOLIO HIGHLIGHT / LOGO GRID */}
      {/* < section className="py-5 bg-white" >
        <div className="container">
          <h3 className="fw-bold text-center mb-4 gradient-text-home" style={{ fontFamily: "'Poppins',sans-serif", fontSize: "2rem" }}>
            Trusted by Individuals & Businesses Nationwide
          </h3>
          {/* Example logos, swap with your/clients/company logos/portfolio }
          <div className="row g-4 justify-content-center align-items-center" style={{ maxWidth: 800, margin: '0 auto' }} data-aos="fade-up">
            {[
              "https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg",
              "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
              "https://upload.wikimedia.org/wikipedia/commons/5/5e/Book_icon_2.png",
              "https://upload.wikimedia.org/wikipedia/commons/7/73/Lion_drawing.svg"
            ].map((logo, i) => (
              <div className="col-3 col-md-2 text-center" key={i}>
                <img
                  src={logo}
                  alt={`Portfolio ${i + 1}`}
                  className="img-fluid"
                  style={{ maxHeight: 60, opacity: 0.83, filter: 'grayscale(60%)' }}
                />
              </div>
            ))}
          </div>
        </div>
        <style>{`
          .gradient-text-home {
            background: linear-gradient(90deg,#6B46C1,#D53F8C 80%);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            -webkit-text-fill-color: transparent;
          }
        `}</style>
      </section > */}
    </div >
  );
}
